import React from 'react';

import { Icon } from 'b3';
import FergusLogo from '../../FergusLogo';
import { parseMentionsWithAnchor } from '../../../utils/StringUtils';
import TimelineItem from './TimelineItem';

export default function ActivityTimelineItem(props) {
	var icon 	= <Icon icon="flag-1" filled/>;

	var avatar = <FergusLogo className="avatar" />;

    return (
        <TimelineItem
        	type="activity"
        	typeLabel="Activity"
        	avatar={avatar}
        	icon={icon}
        >
            <span dangerouslySetInnerHTML={{__html: parseMentionsWithAnchor(props.name)}}></span>
        </TimelineItem>
    );
}






// WEBPACK FOOTER //
// ./app/components/client-timeline/items/ActivityTimelineItem.js